import { ActionBar, Button, Portal } from '@chakra-ui/react'

type DualActionBarProps = {
  visible: boolean

  onCancel: () => void
  cancelLabel?: string
  cancelDisabled?: boolean

  onPrimary: () => void | Promise<void>
  primaryLabel: string
  primaryDisabled?: boolean
  primaryLoading?: boolean

  onSecondary?: () => void | Promise<void>
  secondaryLabel?: string
  secondaryDisabled?: boolean
  secondaryLoading?: boolean
}

export function DualActionBar({
  visible,

  onCancel,
  cancelLabel = 'Abbrechen',
  cancelDisabled = false,

  onPrimary,
  primaryLabel,
  primaryDisabled = false,
  primaryLoading = false,

  onSecondary,
  secondaryLabel = 'Anlegen & neue Aktivität',
  secondaryDisabled = false,
  secondaryLoading = false,
}: DualActionBarProps) {
  if (!visible) return null

  return (
    <ActionBar.Root open>
      <Portal>
        <ActionBar.Positioner>
          <ActionBar.Content
            flexDirection={{ base: 'column', md: 'row' }}
            width={{ base: 'calc(100% - {spacing.6})', md: 'fit-content' }}
          >
            <Button variant="ghost" onClick={onCancel} disabled={cancelDisabled}>
              {cancelLabel}
            </Button>

            <Button
              colorPalette="blue"
              variant="subtle"
              onClick={onPrimary}
              loading={primaryLoading}
              disabled={primaryDisabled || primaryLoading}
            >
              {primaryLabel}
            </Button>

            {onSecondary && (
              <Button
                colorPalette="blue"
                variant="solid"
                onClick={onSecondary}
                loading={secondaryLoading}
                disabled={secondaryDisabled || secondaryLoading}
              >
                {secondaryLabel}
              </Button>
            )}
          </ActionBar.Content>
        </ActionBar.Positioner>
      </Portal>
    </ActionBar.Root>
  )
}
